// @ts-nocheck
import { AccordionSectionPanel, AccordionSectionPresentationProps } from "@insite/mobius/AccordionSection";
import getColor from "@insite/mobius/utilities/getColor";
import resolveColor from "@insite/mobius/utilities/resolveColor";
import { transitionHoverStyles } from "@store/Themes/common/mixins/transition";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { focusStyles } from "@toolkit/Themes/common/mixins";
import { css } from "styled-components";

/* Store Custom Code - Start */
import ArrowiOSDownward from "@store/Library/Components/Toolkit/Icons/ArrowiOSDownward";
import ArrowiOSUpward from "@store/Library/Components/Toolkit/Icons/ArrowiOSUpward";
/* Store Custom Code - End */

const borderWidth = pxToRem(1);
const borderCss = css`
    ${({ theme }) => `${borderWidth} solid ${resolveColor("common.border", theme)}`}
`;

const _headerButtonBaseStyles = () => {
    return css`
        ${focusStyles()}
        padding: ${pxToRem(16, 0)};
        background-color: transparent;
        border: none;
        border-top: ${borderCss};
        border-bottom: ${borderCss};
        color: inherit;
        transition: ${transitionHoverStyles("color")};

        ${({ theme }) => css`
            font-size: ${theme.design.typography.size.large};
            font-weight: ${theme.design.typography.weight.bold};
            line-height: ${theme.design.typography.lineHeight.small};
        `}

        &[aria-expanded="true"] {
            border-bottom-color: transparent;
        }

        &:hover {
            color: ${getColor("primary.contrast") /* Store Custom Code */};
        }
    `;
};

const _headerButtonStyles = () => {
    return css`
        button {
            ${_headerButtonBaseStyles()}

            &:focus,
            &:focus-visible {
                ${_headerButtonBaseStyles()}
                color: ${getColor("secondary") /* Store Custom Code */};
            }
        }
    `;
};

export const accordionFooterSectionProps: AccordionSectionPresentationProps = {
    headerProps: {
        css: css`
            ${_headerButtonStyles()}
            background-color: transparent;
            /* Store Custom Code - Start */
            color: inherit;
            /* Store Custom Code - End */

            ${AccordionSectionPanel} + && {
                ${_headerButtonStyles()}
                margin-top: -${borderWidth};
            }
        `,
    },
    panelProps: {
        css: css`
            padding: ${pxToRem(0, 0, 16)};
            border: none;
            border-bottom: ${borderCss};
        `,
    },
    /* Store Custom Code - Start */
    expandIconProps: {
        src: ArrowiOSDownward,
        color: "primary.contrast",
    },
    collapseIconProps: {
        src: ArrowiOSUpward,
        color: "primary.contrast",
    },
    /* Store Custom Code - End */
};
